module.exports = __webpack_public_path__ + "public/images/dome-mobile.010905331cdbb74783f8cc361251d702.svg";